import React, { useEffect, useRef, useState } from "react";
import { HiDotsHorizontal } from "react-icons/hi";
import { MdAddBox } from "react-icons/md";
import { FaBoxOpen } from "react-icons/fa";
import PartnerPlanPackagesModal from "../modals/PartnerPlanPackagesModal";
import AddPartnerPlanPackageModal from "../modals/AddPartnerPlanPackageModal";
import axios from "axios";
import { app_url } from "../../config";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FaTrash } from "react-icons/fa";
import DeletePartnerPlanConfirmationModal from "../modals/DeletePartnerPlanConfirmationModal";

const PartnerPlanTable = ({
  tabledata,
  isLoading,
  search,
  fetchPartnerPlan,
}) => {
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [showPackageModal, setShowPackageModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showAddPackageModal, setShowAddPackageModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const token = JSON.parse(localStorage.getItem("adminEtijwaal"))?.token;
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [networkIssue, setNetworkIssue] = useState(false);
  const [failed, setFailed] = useState("");
  const navigate = useNavigate();
  const [selectedPlanPackage, setSelectedPlanPackage] = useState(null);
  const [showDeletePlanModal, setShowDeletePlanModal] = useState(false);
  const [planToDelete, setPlanToDelete] = useState(null);
  const tableRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (activeDropdownId && !e.target.closest(".custom-dropdown")) {
        setActiveDropdownId(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [activeDropdownId]);

  // Toggle dropdown
  const toggleDropdown = (id) => {
    setActiveDropdownId((prev) => (prev === id ? null : id)); // Toggle only the clicked dropdown
  };

  const newArr = new Array(12).fill(
    <p className="placeholder-glow">
      <span className="placeholder col-12"></span>
    </p>
  );

  const handleError = (err) => {
    if (err.response) {
      if (err.response.status === 400) {
        toast.error(err.response.data.message || "Bad Request");
      } else if (err.response.status === 401) {
        navigate("/");
      } else if (err.response.status === 500) {
        toast.error(err.response.data.message || "Internal Server Error");
      } else {
        toast.error("An unexpected error occurred.");
      }
    } else {
      setNetworkIssue(true);
      toast.error("Network error. Please check your internet connection.");
      setFailed("Network error. Please check your internet connection.");
    }
  };

  const openPackageModal = (pkg) => {
    setShowPackageModal(true);
    setSelectedPackage(pkg);
  };

  const closePackageModal = () => {
    setShowPackageModal(false);
    setSelectedPackage(null);
  };

  const openAddPlanPackageModal = (pkg) => {
    setSelectedPlan(pkg);
    setShowAddPackageModal(true);
  };

  const closeAddPlanPackageModal = () => {
    setSelectedPlan(null);
    setShowAddPackageModal(false);
  };

  const fetchPackages = () => {
    if (!selectedPackage?.id) return;
    setLoading(true);
    axios
      .get(
        `${app_url}/api/partner/fetchPartnerPlanPackages?plan_id=${selectedPackage.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setPackages(response?.data?.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setShowPackageModal(false);
        handleError(err);
      });
  };

  const handleDeletePackage = (id) => {
    setIsDeleting(true);
    // console.log(id, "ID to delete");
    axios
      .post(
        `${app_url}/api/partner/removePartnerPlanPackage`,
        { partner_plan_package_id: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success) {
          setIsDeleting(false);
          setShowDeleteModal(false);
          toast.success(
            response.data.message || "Package removed successfully"
          );
          if (selectedPlanPackage) {
            fetchPackages();
          }
        } else {
          toast.error(response.data.message || "Failed to delete package");
        }
      })
      .catch((err) => {
        setIsDeleting(false);
        setShowDeleteModal(false);
        handleError(err);
      });
  };

  const removePartnerPlan = (plan) => {
    setIsDeleting(true);
    axios
      .post(
        `${app_url}/api/partner/removePartnerPlan`,
        { partner_plan_id: Number(plan.id) },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setIsDeleting(false);
        setShowDeletePlanModal(false);
        if (response.data.success) {
          toast.success(response.data.message || "Plan removed successfully");
          fetchPartnerPlan(search);
        } else {
          toast.error(response.data.message || "Failed to delete plan");
        }
      })
      .catch((err) => {
        setIsDeleting(false);
        setShowDeletePlanModal(false);
        handleError(err);
      });
  };

  const skeleton = (
    <tbody>
      {newArr.map((item, index) => (
        <tr key={index}>
          <th scope="row" className="py-3 ps-5">
            {item}
          </th>
          <th scope="row" className="py-3">
            {item}
          </th>
          <th scope="row" style={{ textTransform: "none" }} className="py-3">
            {item}
          </th>
          <th scope="row" className="text-center py-3">
            {item}
          </th>
          <th scope="row" className="text-center py-3">
            {item}
          </th>
          <th scope="row" className="text-center py-3">
            {item}
          </th>
        </tr>
      ))}
    </tbody>
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (activeDropdownId && !e.target.closest(".dropdown")) {
        setActiveDropdownId(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [activeDropdownId]);

  return (
    <div
      ref={tableRef}
      className={`table-container ${activeDropdownId ? "dropdown-open" : ""}`}
    >
      <table className="table sm:mt-4 mt-3 table-tb">
        <thead className="">
          <tr className="rounded">
            <th className="tr-tt fw-bold ps-5" scope="col">
              #
            </th>
            <th className="tr-tt fw-bold" scope="col">
              Plan Name
            </th>
            <th className="tr-tt fw-bold" scope="col">
              Discount Offered to Partner
            </th>
            <th className="tr-tt fw-bold" scope="col">
              Profit Margin (on Discounted Price)
            </th>
            <th className="tr-tt fw-bold" scope="col">
              Description
            </th>
            <th className="tr-tt fw-bold" scope="col">
              Actions
            </th>
          </tr>
        </thead>

        {isLoading ? (
          skeleton
        ) : (
          <tbody>
            {tabledata?.data?.result?.length == 0 ? (
              <tr>
                <th className="py-2"></th>
                <th className="py-2"></th>
                <th className="py-4 align-middle">No Data Found</th>
                <th className="py-2"></th>
                <th className="py-2"></th>
                <th className="py-2"></th>
              </tr>
            ) : (
              tabledata?.data?.result?.map((itm, index) => {
                return (
                  <tr key={index}>
                    <th className="py-3 ps-5 align-middle ">
                      <p className="mb-0">{index + 1}</p>
                    </th>
                    <th
                      style={{ textTransform: "none" }}
                      className="py-3 align-middle"
                    >
                      <p className="mb-0 text-muted mb-0">
                        <span className="fw-medium">{itm.plan_name}</span>
                      </p>
                    </th>
                    <th
                      style={{ textTransform: "none" }}
                      className="py-3 align-middle"
                    >
                      <p className="mb-0 text-muted mb-0">
                        <span className="fw-medium">{`${itm.discount_percentage.toFixed(
                          2
                        )}%`}</span>
                      </p>
                    </th>{" "}
                    <th
                      style={{ textTransform: "none" }}
                      className="py-3 align-middle"
                    >
                      <p className="mb-0 text-muted mb-0">
                        <span className="fw-medium">{`${itm.selling_margin_percentage.toFixed(
                          2
                        )}%`}</span>
                      </p>
                    </th>
                    <th
                      style={{ textTransform: "none" }}
                      className="py-3 align-middle"
                    >
                      <p className="mb-0 text-muted mb-0">
                        <span className="fw-medium">
                          {itm.description === null ? "N/A" : itm.description}
                        </span>
                      </p>
                    </th>
                    <th className="py-3 align-middle position-relative">
                      <div
                        className="custom-dropdown"
                        key={`dropdown-${itm.id}`}
                      >
                        <button
                          className="dropdown-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleDropdown(itm.id);
                          }}
                        >
                          <HiDotsHorizontal size={24} />
                        </button>

                        <div
                          className={`custom-dropdown-menu ${
                            activeDropdownId === itm.id ? "show" : ""
                          }`}
                        >
                          <div className="d-flex flex-column">
                            {/* View Packages */}
                            <div
                              className="d-flex items-center pointer px-4 py-1 gap-2 border-bottom"
                              style={{
                                borderColor: "#E9ECEF",
                                textTransform: "none",
                              }}
                              title="View all packages of this plan"
                              onClick={() => openPackageModal(itm)}
                            >
                              <FaBoxOpen size={20} />
                              <p className="mb-0">View Packages</p>
                            </div>
                            {/* Add Package */}
                            <div
                              className="d-flex items-center pointer px-4 py-1 gap-2 border-bottom"
                              style={{
                                borderColor: "#E9ECEF",
                                textTransform: "none",
                              }}
                              title="Add a new package to the plan"
                              onClick={() => {
                                openAddPlanPackageModal(itm);
                              }}
                            >
                              <MdAddBox size={20} />
                              <p className="mb-0">Add Package</p>
                            </div>
                            <div
                              className="d-flex items-center pointer px-4 py-1 gap-2"
                              style={{
                                textTransform: "none",
                              }}
                              title="Delete this partner plan"
                              onClick={() => {
                                setPlanToDelete(itm);
                                setShowDeletePlanModal(true);
                              }}
                            >
                              <FaTrash size={18} />
                              <p className="mb-0">Delete Plan</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                );
              })
            )}
          </tbody>
        )}
      </table>
      {/* Delete Partner Plan Confirmation Modal */}
      <DeletePartnerPlanConfirmationModal
        show={showDeletePlanModal}
        onClose={() => setShowDeletePlanModal(false)}
        onConfirm={() => removePartnerPlan(planToDelete)}
        title="Delete Partner Plan"
        message={`Are you sure you want to delete the plan "${planToDelete?.plan_name}"?`}
        confirmText={isDeleting ? "Deleting..." : "Delete"}
        confirmButtonVariant="danger"
        isLoading={isDeleting}
      />
      {/* Packages Modal */}
      <PartnerPlanPackagesModal
        show={showPackageModal}
        onClose={closePackageModal}
        selectedPackage={selectedPackage}
        onDeleteClick={(pkg) => {
          setSelectedPlanPackage(pkg);
          setShowDeleteModal(true);
        }}
        setShowDeleteModal={setShowDeleteModal}
        handleDeletePackage={handleDeletePackage}
        showDeleteModal={showDeleteModal}
        fetchPackages={fetchPackages}
        failed={failed}
        networkIssue={networkIssue}
        packages={packages}
        loading={loading}
        isDeleting={isDeleting}
      />
      {/* Add Package in Partner Plan Modal   */}
      <AddPartnerPlanPackageModal
        show={showAddPackageModal}
        onClose={closeAddPlanPackageModal}
        selectedPlan={selectedPlan}
      />
    </div>
  );
};

export default PartnerPlanTable;
